<template>
  <div>
    <h1>
      <b>Mis ordenes de servicio</b>
    </h1>
    <div class="form-group pull-left">
      <router-link to="/ordenes/crear">
        <button type="button" class="btn btn-success md-elevation-24">
          <i class="fa fa-plus-circle"></i> Crear orden servicio
        </button>
      </router-link>
    </div>
    <div>
      <div
        class="form-group pull-right"
        style="padding-right: 10px; padding-left: 10px; text-align: right;"
      >
        <div class="row">
          <div
            class="col-md-12"
            style="display: flex;
                align-items: center;
                justify-content: center;"
          >
            <div>
              <a-input-search
                size="large"
                v-model="filter"
                v-on:keyup.enter="onKeyPress"
                placeholder="Buscar orden "
                @search="sendRequestOrdenes"
              />
            </div>
            <div style="padding: 5px;">
              <a-button
                shape="circle"
                :loading="procesando"
                type="danger"
                icon="close"
                @click="limpiarFiltros"
              ></a-button>
            </div>
          </div>
        </div>
        <a-pagination
          style="padding-top: 10px"
          @change="onChange"
          :current="page"
          :total="pagination.totalPage"
        />
      </div>

      <span class="counter pull-right"></span>
      <div class="row">
        <div id="table" class="col-xs-12 table-responsive">
          <Load v-if="procesando" text="Buscando información"></Load>
          <md-table
            v-else
            v-model="row"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            md-card
          >
            <md-table-empty-state
              md-label="No se encontrarón datos"
            ></md-table-empty-state>
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              :style="
                rol === 'ANALISTA' &&
                item.proceso &&
                JSON.parse(item.proceso).analisis.terminado
                  ? 'background-color: #85ff008c;'
                  : rol === 'TECNICO' &&
                    item.estado &&
                    JSON.parse(item.estado).estado === 'Pendiente'
                  ? 'background-color: rgba(255, 0, 47, 0.28);'
                  : ''
              "
            >
              <md-table-cell
                md-label="N° OS"
                md-sort-by="ordenId"
                md-numeric
                >{{ item.ordenId }}</md-table-cell
              >
              <md-table-cell
                md-label="FECHA CREACIÓN"
                md-sort-by="created_at"
                >{{ `${item.created_at}` }}</md-table-cell
              >
              <md-table-cell
                md-label="CLIENTE"
                md-sort-by="clienteNombre"
              >
                <router-link
                  :to="{
                    name: 'editar-orden-servicio',
                    params: {
                      ordenId: item.ordenId,
                      proviene: 'personal',
                    },
                  }"
                >
                  <a href="#">{{
                    `${item.clienteNombre} ${
                      item.clienteApellidos
                    } - ${item.celularCliente}`
                  }}</a>
                </router-link>
              </md-table-cell>
              <md-table-cell
                md-label="QUIÉN RECIBE"
                md-sort-by="usuario_recibe"
                >{{
                  item.usuario_recibe.split('-')[1]
                }}</md-table-cell
              >
              <md-table-cell
                md-label="TÉCNICO"
                md-sort-by="tecnicoNombre"
                >{{
                  `${item.tecnicoNombre} ${item.tecnicoApellidos}`
                }}</md-table-cell
              >
              <md-table-cell
                md-label="SERVICIO"
                md-sort-by="servicio"
              >
                <router-link
                  :to="{
                    name: 'editar-orden-servicio',
                    params: {
                      ordenId: item.ordenId,
                      proviene: 'personal',
                    },
                  }"
                >
                  <a href="#">
                    {{
                      `${
                        row.servicio === 'Análisis' ||
                        item.servicio === 'Analisis'
                          ? item.servicio_realizado != null
                            ? item.servicio_realizado.toUpperCase()
                            : 'ANÁLISIS EN PROCESO'
                          : item.servicio.toUpperCase()
                      }`
                    }}
                  </a>
                </router-link>
              </md-table-cell>
              <md-table-cell md-label="MARCA" md-sort-by="marca">{{
                item.marca
              }}</md-table-cell>
              <md-table-cell md-label="ESTADO" md-sort-by="estado">
                <router-link
                  :to="{
                    name: 'editar-orden-servicio',
                    params: {
                      ordenId: item.ordenId,
                      proviene: 'personal',
                    },
                  }"
                >
                  <a href="#">
                    {{ `${JSON.parse(item.estado).estado}` }}
                    <i
                      v-if="
                        JSON.parse(item.estado).estado === 'Pendiente'
                      "
                      class="fa fa-info-circle"
                    ></i>
                    <md-tooltip
                      v-if="
                        JSON.parse(item.estado).pendiente.autorizacion
                      "
                      md-direction="right"
                      >Autorización</md-tooltip
                    >
                    <md-tooltip
                      v-if="
                        JSON.parse(item.estado).pendiente.repuesto
                      "
                      md-direction="right"
                      >Repuesto</md-tooltip
                    >
                    <md-tooltip
                      v-if="
                        JSON.parse(item.estado).pendiente.cotizacion
                      "
                      md-direction="right"
                      >Cotización</md-tooltip
                    >
                  </a>
                </router-link>
              </md-table-cell>
              <md-table-cell
                md-label="VALOR SERVICIO"
                md-sort-by="precio"
                >{{ item.precio | currency }}</md-table-cell
              >

              <md-table-cell
                translate="no"
                md-label="TERMINADO"
                md-sort-by="terminado"
                >{{
                  item.fecha_terminado
                    ? item.fecha_terminado
                    : 'SIN TERMINAR'
                }}</md-table-cell
              >
              <md-table-cell
                translate="no"
                md-label="ENTREGADO"
                md-sort-by="entregado"
                >{{
                  item.fecha_entrega
                    ? item.fecha_entrega
                    : 'SIN ENTREGAR'
                }}</md-table-cell
              >
              <md-table-cell md-label="OPCIONES">
                <a-dropdown>
                  <a-menu slot="overlay" @click="handleMenuClick">
                    <a-menu-item key="1">
                      <router-link
                        :to="{
                          name: 'editar-orden-servicio',
                          params: {
                            ordenId: item.ordenId,
                            proviene: 'personal',
                          },
                        }"
                      >
                        <a href="#">Ver detalle</a>
                      </router-link>
                    </a-menu-item>
                    <a-menu-item key="2" v-if="item.terminado === 1">
                      <a @click="entregarOrden(item.ordenId)" href="#"
                        >Entregar</a
                      >
                    </a-menu-item>
                  </a-menu>
                  <a-button type="primary" style="margin-left: 8px">
                    Opciones
                    <a-icon type="down" />
                  </a-button>
                </a-dropdown>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 form-inline">
          <!-- <datatable-pager v-model="page" type="abbreviated" :per-page="per_page"></datatable-pager> -->
          <!-- <a-pagination  @change="onChange" :current="page" :total="pagination.totalPage" /> -->
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import Load from '../Helpers/Loading';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { mapState } from 'vuex';
import Moment from 'moment';
export default {
  name: 'mis-ordenes',
  components: {
    Loading,
    Load,
  },
  computed: mapState(['usuario', 'rol', 'usuarioId']),
  data() {
    return {
      filter: '',
      currentSort: 'ordenId',
      currentSortOrder: 'desc',
      loading: true,
      procesando: false,
      pagination: {
        page: 1,
        total: 0,
        totalPage: 10,
        search: '',
      },
      page: 1,
      row: [],
      per_page: 100,
    };
  },
  watch: {
    filter() {
      // this.pagination.search = this.filter
      // this.pagination.page = 1
      // this.procesando = true
      // this.getOrdenes()
    },
  },
  created() {
    this.getOrdenes();
  },
  mounted() {},
  methods: {
    sendRequestOrdenes() {
      this.pagination.search = this.filter;
      this.page = 1;
      this.pagination.page = 1;
      this.procesando = true;
      this.getOrdenes();
    },
    onKeyPress() {
      this.sendRequestOrdenes();
    },
    limpiarFiltros() {
      this.filter = '';
      this.sendRequestOrdenes();
    },
    onCancel() {},
    onChange(page) {
      this.loading = true;
      this.page = page;
      this.pagination.page = page;
      this.getOrdenes();
    },
    getOrdenes() {
      // this.loading = true
      let data = {
        filter: this.pagination,
        userId: this.usuarioId,
        orden: {
          entidad: this.currentSort,
          tipo: this.currentSortOrder,
        },
      };
      ServiceApi.post(`/ordenes/list`, data)
        .then(response => {
          // console.log('RESPUESTA:::', response);
          let data = response.data.data;
          this.row = data.ordenes.map((item, key) => {
            item.clienteFullName = `${item.clienteNombre} ${
              item.clienteApellidos
            }`;
            item.tecnicoFullName = `${item.tecnicoNombre} ${
              item.tecnicoApellidos
            }`;
            return item;
          });
          let pagination = data.paginacion;
          this.pagination.totalPage = pagination.lastPage * 10;
          this.pagination.total = pagination.total;
          // if(!data.ordenes.length)this.$noty.warning('No se encontraron ordenes de servicio creadas')
          this.loading = false;
          this.procesando = false;
        })
        .catch(err => {
          // this.$noty.error('Ocurrio un error al consultar las tarjetas')
          this.loading = false;
          this.procesando = false;
          this.$router.push('/');
        });
    },
    showModal(ordenId) {
      Swal.fire({
        type: 'success',
        title: `Se acaba de generar la entrega de la orden # ${ordenId}`,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    entregarOrden(ordenId) {
      this.loading = true;
      let data = {
        ordenId,
        entregado: true,
        fecha: Moment().format('YYYY/MM/DD h:mm:ss'),
      };
      ServiceApi.post('/orden/entregar', data)
        .then(response => {
          this.getOrdenes();
          this.loading = false;
          this.showModal(ordenId);
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar las tarjetas'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
    customSort(value) {
      if (
        this.currentSort === 'ordenId' ||
        this.currentSort === 'precio' ||
        this.currentSort === 'terminado' ||
        this.currentSort === 'entregado'
      ) {
        this.getOrdenes();
      } else {
        return value.sort((a, b) => {
          const sortBy = this.currentSort;
          if (this.currentSortOrder === 'desc') {
            return a[sortBy].localeCompare(b[sortBy]);
          }

          return b[sortBy].localeCompare(a[sortBy]);
        });
      }
    },
    handleMenuClick() {},
  },
};
</script>
